/**
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 * @enum {string}
 */
var _ol_source_State_ = {
  UNDEFINED: 'undefined',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error'
};

export default _ol_source_State_;




//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/node_modules/ol/source/state.js
// module id = ../../../../ol/source/state.js
// module chunks = vendor